export const LABEL_COMING_SOON = 'Coming soon';
export const LABEL_SPLIT_COMING_SOON = 'Coming\nsoon';
export const LABEL_NOT_AVAILABLE = 'Not available';
